var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inline-svg',{class:("corner corner-" + _vm.position),attrs:{"src":require('@/assets/svg/corner.svg'),"width":"20","height":"20","aria-label":"corner","aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }